import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import MaskInput from 'components/MaskedInput';
import CurrentStatusField from 'features/Croptimizer/components/Fields/CurrentStatusField';
import TargetStatusField from 'features/Croptimizer/components/Fields/TargetStatusField';

interface Props {
  errorTarget: string;
  currentSec: string;
  setCurrentSec: (value: string) => void;
  handleChangeTarget: (value: string) => void;
  errorCurrentSecHandle: string;
  targetph: string;
  targetSec: string;
  currentSecAuto: string;
  errorTargetSec: string;
  disabled: boolean;
}

const StatusCropRotation: FC<Props> = ({
  currentSec,
  setCurrentSec,
  errorCurrentSecHandle,
  targetSec,
  currentSecAuto,
  errorTargetSec,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap divide-x divide-primitiveGrey sm:divide-x-0 sm:divide-y mx-[-1rem] sm:mx-0 mt-8">
      <div className="w-1/2 sm:w-full px-4 sm:px-0 sm:pb-4">
        <div className="text-black font-bold text-xl sm:text-lg mb-8">
          {t('currentStatus')}
        </div>
        <div className="my-6">
          <CurrentStatusField />
        </div>
        <div className="w-full">
          <MaskInput
            value={currentSec}
            className="w-full"
            titleClassName={`${
              disabled ? 'bg-disable-gradient' : ''
            }  top-[-9px] left-[8px]`}
            title="S/CEC"
            onChange={setCurrentSec}
            isGreyText={currentSec === currentSecAuto}
            redBorder={errorCurrentSecHandle.length > 0}
            disabled={disabled}
            suffix=" %"
          />
          <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
            {errorCurrentSecHandle.length > 0 && (
              <div> {errorCurrentSecHandle}</div>
            )}
          </div>
        </div>
      </div>
      <div className="w-1/2 sm:w-full px-4 sm:px-0 sm:pt-4">
        <div className="text-black font-bold text-xl sm:text-lg mb-8">
          {t('targetStatus')}
        </div>
        <div className="w-full mb-8">
          <TargetStatusField />
        </div>
        <div className="w-full">
          <MaskInput
            disabled
            value={targetSec}
            className="w-full"
            titleClassName="bg-disable-gradient top-[-9px] left-[8px]"
            title="S/CEC"
            isGreyText
            suffix=" %"
          />
          <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
            {errorTargetSec.length > 0 && <div> {errorTargetSec}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusCropRotation;
